<template lang="pug">
.radio(:class="{ 'disabled': disabled }")
  .choice(v-for="(item, index) in items", :key="index", @click="emit(index, item.value)", :class="`${item.selected ? 'selected' : ''}`")
    .radio-circle(:class="`${item.selected ? 'filled' : ''}`")
    .radio-icon(v-if="item.icon"): i(:class="`mdi mdi-${item.icon}`")
    .radio-text {{ item.string }}
      span {{ item.description }}
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * Emits the choosen one to parent
     * @param {String|Boolean} value
     */
    emit(index, value) {
      if (this.disabled) {
        return;
      }

      this.$emit('input', { index, value });
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.radio {
  .choice {
    align-items: center;
    border: 2px solid #E5E9EC;
    border-radius: 4px;
    display: flex;
    margin-bottom: 8px;
    padding: 15px;

    &:hover {
      cursor: pointer;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.selected {
      background-color: #EEF5FF;
      border-color: #0060FF;

      .radio-text {
        font-weight: 500;
      }

      .radio-icon {
        color: #0060FF;
      }
    }
  }

  &.no-border {
    .choice {
      border: 0;
      border-radius: 0;
      padding: 0 !important;
      margin: 0;

      &:not(:last-child) {
        margin-bottom: 10px;
      }

      &.selected {
        background-color: transparent;
        border-color: none;
      }
    }
  }

  &.disabled {
    .choice {
      cursor: not-allowed;

      &.selected {
        border-color: gray;
      }
    }
  }

  .radio-circle {
    align-items: center;
    border: 2px solid #B7BDC6;
    border-radius: 12px;
    display: inline-flex;
    min-height: 24px;
    height: 24px;
    margin-right: 10px;
    justify-content: center;
    position: relative;
    min-width: 24px;
    width: 24px;

    &.filled {
      &:after {
        background-color: #0360FF;
        border-radius: 100%;
        content: "";
        height: 12px;
        width: 12px;
      }
    }
  }

  .radio-icon {
    color: #8591A0;
    font-size: 2rem;
    font-weight: 100;
    margin-right: .8rem;
  }

  .radio-text {
    font-weight: 400;
    line-height: 1.2;
    word-break: break-word;
    font-size: 1rem;
    span {
      color: #8591A0;
      font-size: .9rem;
      display: block;
    }
  }

  &.small {
    .choice {
      padding: 10px;
    }

    .radio-circle {
      height: 20px;
      min-height: 20px;
      width: 20px;
      min-width: 20px;

      &:after {
        height: 10px;
        width: 10px;
      }
    }

    .radio-text {
      font-size: .9rem;

      span {
        font-size: .8rem;
      }
    }
  }

  &.horizontal {
    display: flex;

    & > * {
      margin: 0 5px;
      flex: 1;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
